module.exports = __webpack_public_path__ + "img/wafaCash.2134a04b.png";